import React from 'react';

/**
 * Full-screen notice shown when REACT_APP_DEPLOYING=true.
 * Blocks the rest of the app so users see only this page during deploy.
 */
const Deploying = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '24px',
        background: 'linear-gradient(160deg, #EFF6FF 0%, #F8FAFC 45%, #EEF2FF 100%)',
        fontFamily: 'Manrope, sans-serif',
      }}
    >
      <div style={{ maxWidth: 480, width: '100%', textAlign: 'center' }}>
        <img
          src="./assets/images/logo-color.svg"
          alt="GradMap"
          style={{ height: 48, marginBottom: 32 }}
        />
        <h1
          style={{
            fontSize: 28,
            fontWeight: 700,
            color: '#1E293B',
            marginBottom: 12,
            lineHeight: 1.3,
          }}
        >
          We&apos;re temporarily unavailable
        </h1>
        <p
          style={{
            fontSize: 16,
            color: '#64748B',
            marginBottom: 28,
            lineHeight: 1.6,
          }}
        >
          GradMap is briefly paused while we deploy updates. Please check back in a few minutes.
        </p>
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            padding: '10px 16px',
            borderRadius: 8,
            background: '#DBEAFE',
            color: '#1D4ED8',
            fontSize: 13,
            fontWeight: 600,
          }}
        >
          <span
            style={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              background: '#3B82F6',
              animation: 'gm-deploy-pulse 1.2s ease-in-out infinite',
            }}
          />
          Deploying…
        </div>
        <style>
          {`
            @keyframes gm-deploy-pulse {
              0%, 100% { opacity: 0.35; transform: scale(0.9); }
              50% { opacity: 1; transform: scale(1.1); }
            }
          `}
        </style>
      </div>
    </div>
  );
};

export default Deploying;
